module.exports = __webpack_public_path__ + "static/img/friend-invitation-bubble-txt.ab695aa.png";